import css from 'styled-jsx/css';
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .pill-capacity {
    &--option {
      position: relative;
      display: block;
      cursor: pointer;
      &:hover .pill-capacity--container:not(.pill-capacity--container--selected) {
        background-color: #EEEEEE;
      }
    }
    &--input {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      opacity: 0;
      cursor: pointer;
      &:focus-visible + .pill-capacity--container {
        outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
        outline-offset: 3px;
      }
    }
    &--container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 5rem;
      height: 2.25rem;
      padding: 0rem 0.5rem;
      border: 0.125rem solid #dddddd;
      border-radius: 2rem;
      &--selected {
        border: 0.125rem solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
        border-radius: 2rem;
        background-color: ${getColor(COLOR_DICTIONARY.BLUE_200)};
      }
      &:not(&--selected) {
        &:hover {
          background-color: #EEEEEE;
        }
      }
    }
  }
`;
